import _ from 'lodash';

const moduleName = 'ProspectingProjectTask';
const modulePath = _.kebabCase(moduleName);

export default {
  moduleName,
  modulePath,
};
